import React from 'react';
import Container from './styles'
import Failed from './Failed'
import Successful from './Successful'

 const Alert=({state,amount, setOrderAlert})=>{
   return ( 
     <Container>
      <div className='Alert'>
     
            <div className='AlertContainer'>
              {state ?<Successful value={state} amount={amount}/>: <Failed setOrderAlert={setOrderAlert}/>}
            </div>
        </div>
    </Container>
    )
}

export default Alert;